import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import styles from "assets/jss/components/customcomponents/typographyStyle.js";

const useStyles = makeStyles(styles);

export default function InputLabel(props) {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={classes.defaultFontStyle + " " + classes.inputLabel} style={{marginTop:props.top}}>
      {children}
    </div>
  );
}

InputLabel.propTypes = {
  children: PropTypes.node
};
